import styled from 'styled-components';

export const ProductsSection = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  padding: 0 10px;
`;

export const SectionTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: oklch(0.252 0 0);
  margin: 0;
  font-family: inherit;

  @media (max-width: 768px) {
    font-size: 1.125rem;
  }
`;

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
  border: none;
  border-radius: 0;
  overflow: visible;
  background: transparent;
  box-shadow: none;
  margin-left: -20px;
  margin-right: -20px;
`;

export const ProductCard = styled.div<{ $soldOut?: boolean }>`
  background: oklch(1 0 0);
  overflow: hidden;
  display: grid;
  grid-template-columns: 110px 1fr auto; 
  align-items: start;
  min-height: 100px;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid oklch(0.9683 0.0069 247.9);
  box-shadow: none;
  padding: 15px 20px;
  gap: 0;
  opacity: ${props => props.$soldOut ? '0.6' : '1'};
  position: relative;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${props => props.$soldOut ? 'oklch(1 0 0)' : 'oklch(0.9842 0.0034 247.86)'};
  }

  @media (max-width: 768px) {
    min-height: 100px;
    grid-template-columns: 100px 1fr auto;
    padding: 12px 20px;
  }
`;

export const ProductImage = styled.div`
  width: 90px;
  height: 90px;
  border-radius: 8px;
  overflow: visible;
  position: relative;
  background-color: oklch(0.9683 0.0069 247.9);
  grid-row: 1 / span 2;

  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
  }
`;

export const ImageClip = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
`;

export const ProductDetails = styled.div`
  padding: 0 0 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  min-height: 90px;

  @media (max-width: 768px) {
    padding: 0;
    min-height: 80px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  flex-wrap: wrap;
  grid-column: 2 / span 2;
`;

export const ProductTitle = styled.h3`
  font-size: 0.9375rem;
  font-weight: 600;
  margin: 0;
  color: oklch(0.252 0 0);
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 0.8125rem;
  }
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 8px;
  position: relative;
`;

export const ProductDesc = styled.p<{ $isExpanded?: boolean }>`
  font-size: 0.8125rem;
  color: oklch(0.5693 0 0);
  margin: 0;
  margin-left: 10px;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: ${props => props.$isExpanded ? 'unset' : '1'};
  line-clamp: ${props => props.$isExpanded ? 'unset' : '1'};
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    -webkit-line-clamp: ${props => props.$isExpanded ? 'unset' : '2'};
    line-clamp: ${props => props.$isExpanded ? 'unset' : '2'};
  }
`;

export const HiddenDesc = styled.p`
  font-size: 0.8125rem;
  line-height: 1.5;
  margin: 0;
  margin-left: 10px;
  position: absolute;
  visibility: hidden;
  height: auto;
  overflow: visible;
  white-space: normal;
  word-wrap: break-word;
  pointer-events: none;
  z-index: -1;
  top: 0;
  left: 0;

  @media (max-width: 768px) {
    font-size: 0.75rem;
  }
`;

export const ReadMoreButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-top: 2px;
  color: var(--primary-color, oklch(0.65 0.24 33.09));
  font-size: 0.75rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const ProductPrice = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
`;

export const CurrentPrice = styled.span`
  font-weight: 700;
  color: oklch(0.2264 0 0);
  font-size: 1rem;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    font-size: 0.9375rem;
  }
`;

export const OldPrice = styled.span`
  color: oklch(0.738 0 0);
  text-decoration: line-through;
  font-size: 0.8125rem;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    font-size: 0.75rem;
  }
`;

export const ProductAction = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 90px;
  
  @media (max-width: 768px) {
    min-height: 80px;
  }
`;

export const AddButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: ${props => props.disabled ? 'oklch(0.869 0.0198 252.89)' : 'var(--primary-color, oklch(0.65 0.24 33.09))'};
  color: ${props => props.disabled ? 'oklch(0.683 0 0)' : 'oklch(1 0 0)'};
  border: none;
  border-radius: 9999px;
  min-width: 80px;
  height: 36px;
  padding: 0 10px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s;
  box-shadow: ${props => props.disabled ? 'none' : '0 2px 8px oklch(0.65 0.24 33.09 / 0.35)'};
  font-size: 11px;
  font-weight: 600;
  font-family: inherit;

  svg {
    flex-shrink: 0;
  }

  .spinner {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  &:active {
    transform: ${props => props.disabled ? 'none' : 'scale(0.95)'};
    background-color: ${props => props.disabled ? 'oklch(0.869 0.0198 252.89)' : 'oklch(0.60 0.23 33.01)'};
    box-shadow: ${props => props.disabled ? 'none' : '0 1px 4px oklch(0.65 0.24 33.09 / 0.3)'};
  }

  &:hover {
    background-color: ${props => props.disabled ? 'oklch(0.869 0.0198 252.89)' : 'oklch(0.60 0.23 33.01)'};
    color: ${props => props.disabled ? 'oklch(0.683 0 0)' : 'oklch(1 0 0)'};
    box-shadow: ${props => props.disabled ? 'none' : '0 4px 12px oklch(0.65 0.24 33.09 / 0.45)'};
  }

  @media (max-width: 768px) {
    min-width: 75px;
    height: 34px;
    font-size: 11px;
  }
`;

export const SoldOutBadge = styled.div`
  background-color: oklch(0.61 0.25 28.5);
  color: oklch(1 0 0);
  font-size: 0.75rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 9999px;
  text-align: center;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 0.6875rem;
    padding: 3px 10px;
  }
`;

export const NewBadge = styled.div`
  background-color: oklch(0.61 0.25 28.5);
  color: oklch(1 0 0);
  font-size: 0.625rem;
  font-weight: 400;
  padding: 2px 8px;
  border-radius: 9999px;
  text-align: center;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 2px 4px oklch(0.61 0.25 28.5 / 0.3);

  @media (max-width: 768px) {
    font-size: 0.5625rem;
    padding: 2px 6px;
  }
`;

export const PreOrderBadge = styled.div`
  background-color: oklch(0.7652 0.1752 62.57);
  color: oklch(1 0 0);
  font-size: 0.625rem;
  font-weight: 400;
  padding: 2px 8px;
  border-radius: 9999px;
  text-align: center;
  white-space: nowrap;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 0.5625rem;
    padding: 2px 6px;
  }
`;

export const TimerBadge = styled.div`
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--primary-color, oklch(0.65 0.24 33.09));
  color: oklch(1 0 0);
  font-size: 0.6rem;
  font-weight: 700;
  padding: 2px 12px;
  border-radius: 9999px;
  white-space: nowrap;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px oklch(0.65 0.24 33.09 / 0.4);
  z-index: 3;
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: 4px;

  @media (max-width: 768px) {
    font-size: 0.55rem;
    padding: 2px 6px;
    bottom: -9px;
  }
`;

export const PrepTimeText = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.6875rem;
  font-weight: 600;
  color: oklch(0.5553 0.1455 49);
  background: oklch(1 0 0)8f0;
  border: 1px solid oklch(0.9045 0.0389 72.34);
  padding: 3px 7px;
  border-radius: 6px;
  margin-top: 4px;

  @media (max-width: 768px) {
    font-size: 0.625rem;
    padding: 2px 6px;
    gap: 3px;
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background-color: oklch(1 0 0);
  border-radius: 12px;
  text-align: center;
  margin: 0 20px;
  box-shadow: 0 2px 8px oklch(0 0 0 / 0.05);
`;

export const EmptyStateText = styled.p`
  margin-top: 16px;
  font-size: 1rem;
  color: oklch(0.5103 0 0);
  font-weight: 500;
`;

// Modal Styles
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: oklch(1 0 0);
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContent = styled.div`
  background: oklch(1 0 0);
  border-radius: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  animation: slideUp 0.3s ease-out;
  display: flex;
  flex-direction: column;

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 15px;
  left: 15px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: oklch(1 0 0 / 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s;
  color: oklch(0.3211 0 0);
  box-shadow: 0 2px 8px oklch(0 0 0 / 0.1);

  &:hover {
    background: oklch(1 0 0 / 1);
    transform: scale(1.05);
    box-shadow: 0 4px 12px oklch(0 0 0 / 0.15);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const ModalImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 50vh;
  min-height: 300px;
  background: oklch(0.9683 0.0069 247.9);
  border-radius: 0;
  overflow: hidden;
  flex-shrink: 0;

  @media (max-width: 768px) {
    height: 45vh;
    min-height: 250px;
  }
`;

export const ModalImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ModalNewBadge = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: oklch(0.61 0.25 28.5);
  color: oklch(1 0 0);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 9999px;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 2px 8px oklch(0.61 0.25 28.5 / 0.4);
  z-index: 5;
`;

export const ModalPreOrderBadge = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: oklch(0.7652 0.1752 62.57);
  color: oklch(1 0 0);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 9999px;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 2px 8px oklch(0.7652 0.1752 62.57 / 0.4);
  z-index: 5;
`;

export const ModalBody = styled.div`
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const ModalTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: oklch(0.252 0 0);
  margin: 0 0 16px 0;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 1.25rem;
    margin-bottom: 12px;
  }
`;

export const ModalDescription = styled.p`
  font-size: 1rem;
  color: oklch(0.5103 0 0);
  line-height: 1.6;
  margin: 0 0 24px 0;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 0.9375rem;
    margin-bottom: 20px;
  }
`;

export const ModalPrepTime = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: oklch(0.5553 0.1455 49);
  background: oklch(1 0 0)8f0;
  border: 1px solid oklch(0.9045 0.0389 72.34);
  padding: 5px 10px;
  border-radius: 8px;
  margin-bottom: 14px;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    padding: 4px 8px;
  }
`;

export const ModalPriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid oklch(0.9683 0.0069 247.9);
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin-bottom: 20px;
    padding-bottom: 20px;
  }
`;

export const ModalCurrentPrice = styled.span`
  font-weight: 700;
  color: oklch(0.2264 0 0);
  font-size: 1.5rem;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

export const ModalOldPrice = styled.span`
  color: oklch(0.738 0 0);
  text-decoration: line-through;
  font-size: 1.125rem;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const ModalAddButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: ${props => props.disabled ? 'oklch(0.869 0.0198 252.89)' : 'var(--primary-color, oklch(0.65 0.24 33.09))'};
  color: ${props => props.disabled ? 'oklch(0.683 0 0)' : 'oklch(1 0 0)'};
  border: none;
  border-radius: 8px;
  height: 52px;
  padding: 0 20px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s;
  box-shadow: ${props => props.disabled ? 'none' : '0 2px 8px oklch(0.65 0.24 33.09 / 0.35)'};
  font-size: 0.9375rem;
  font-weight: 700;
  font-family: inherit;
  flex-shrink: 0;

  svg {
    flex-shrink: 0;
  }

  .spinner {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  &:active {
    transform: ${props => props.disabled ? 'none' : 'scale(0.98)'};
    box-shadow: ${props => props.disabled ? 'none' : '0 1px 4px oklch(0.65 0.24 33.09 / 0.3)'};
  }

  &:hover {
    background-color: ${props => props.disabled ? 'oklch(0.869 0.0198 252.89)' : 'oklch(0.60 0.23 33.01)'};
    box-shadow: ${props => props.disabled ? 'none' : '0 4px 12px oklch(0.65 0.24 33.09 / 0.45)'};
  }

  @media (max-width: 768px) {
    height: 48px;
    font-size: 0.875rem;
  }
`;

export const ModalSoldOutButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: oklch(0.61 0.25 28.5);
  color: oklch(1 0 0);
  border: none;
  border-radius: 8px;
  height: 52px;
  padding: 0 20px;
  cursor: not-allowed;
  font-size: 1rem;
  font-weight: 700;
  font-family: inherit;
  opacity: 0.8;
  flex-shrink: 0;

  @media (max-width: 768px) {
    height: 48px;
    font-size: 0.9375rem;
  }
`;

// Fullscreen Image Styles
export const FullscreenImageOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: oklch(0 0 0 / 0.95);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease-out;
  cursor: pointer;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const FullscreenImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  cursor: default;
`;

export const FullscreenImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  animation: zoomIn 0.3s ease-out;

  @keyframes zoomIn {
    from {
      transform: scale(0.9);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

export const FullscreenImageCloseButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: oklch(1 0 0 / 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s;
  color: oklch(0.3211 0 0);
  box-shadow: 0 2px 8px oklch(0 0 0 / 0.2);

  &:hover {
    background: oklch(1 0 0 / 1);
    transform: scale(1.05);
    box-shadow: 0 4px 12px oklch(0 0 0 / 0.3);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    top: 15px;
    left: 15px;
    width: 40px;
    height: 40px;
  }
`;

// ==================== Skeleton Styles ====================

const shimmer = `
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const SkeletonBase = styled.div`
  ${shimmer}
  background: linear-gradient(
    90deg,
    oklch(0.9683 0.0069 247.9) 0%,
    oklch(0.9288 0.0126 255.51) 20%,
    oklch(0.9683 0.0069 247.9) 40%,
    oklch(0.9683 0.0069 247.9) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
  border-radius: 4px;
`;

export const SkeletonCard = styled.div`
  background: oklch(1 0 0);
  overflow: hidden;
  display: grid;
  grid-template-columns: 110px 1fr auto;
  align-items: start;
  min-height: 100px;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid oklch(0.9683 0.0069 247.9);
  box-shadow: none;
  padding: 15px 20px;
  gap: 0;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    min-height: 100px;
    grid-template-columns: 100px 1fr auto;
    padding: 12px 20px;
  }
`;

export const SkeletonImage = styled(SkeletonBase)`
  width: 90px;
  height: 90px;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
  }
`;

export const SkeletonDetails = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  min-height: 90px;
  gap: 8px;

  @media (max-width: 768px) {
    min-height: 80px;
    gap: 6px;
  }
`;

export const SkeletonTitle = styled(SkeletonBase)`
  width: 70%;
  height: 16px;
  border-radius: 4px;

  @media (max-width: 768px) {
    width: 80%;
    height: 14px;
  }
`;

export const SkeletonDesc = styled(SkeletonBase)`
  width: 90%;
  height: 12px;
  border-radius: 4px;

  @media (max-width: 768px) {
    width: 95%;
    height: 10px;
  }
`;

export const SkeletonPrice = styled(SkeletonBase)`
  width: 60px;
  height: 18px;
  border-radius: 4px;
  margin-top: 4px;

  @media (max-width: 768px) {
    width: 50px;
    height: 16px;
  }
`;

export const SkeletonAction = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 90px;

  @media (max-width: 768px) {
    min-height: 80px;
  }
`;

export const SkeletonButton = styled(SkeletonBase)`
  width: 80px;
  height: 36px;
  border-radius: 9999px;

  @media (max-width: 768px) {
    width: 75px;
    height: 36px;
  }
`;
